import { ProductBrandUpdatePage } from '@/features/product-brand/pages/ProductBrandUpdatePage';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-brand/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_brand.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductBrandUpdatePage,
})
